import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Home.css";

// Images
import banner1 from "../assets/Banner-1.png";
import banner2 from "../assets/banner2.jpeg";
import banner3 from "../assets/Banner3.png";

// Components
import AboutSection from "../components/AboutSection";
import ServiceOffer from "../components/ServiceOffer";
import Logo from "../components/Logo";
import Journey from "../components/Journey";
import NeedAbout from "../components/NeedAbout";
import SmarterMove from "../components/SmarterMove";

export default function Home() {
  const banners = [
    {
      subheading: "Smart Printing. Smarter Savings.",
      heading:
        "Reduce your printing costs by up to 20% with 24/7 local support and a global supply network.",
      button: "Talk to Us Today",
      link: "/contact",
      image: banner1,
    },

    {
      subheading:
        "Cut Your Printing Costs by 20% Without Compromising on Quality.",
      heading:
        "Tired of overpriced supplies and inconsistent service?<br />We’ll help you fix it fast.",
      button: "Start Saving Today",
      link: "/services",
      image: banner2,
    },

    {
      subheading:
        "From the UAE to the USA to Nigeria, Trusted by Businesses Worldwide.",
      heading:
        "RECLA brings global experience to your doorstep, with expert local support for Nigerian businesses.",
      button: "Explore Our Services",
      link: "/about",
      image: banner3,
    },
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [banners.length]);

  return (
    <div className="home">
      {/* Hero Slider Section */}
      <section
        className="hero-slider"
        style={{ backgroundImage: `url(${banners[current].image})` }}
      >
        <div className="overlay">
          <div className="content">
            <h4>{banners[current].subheading}</h4>
            <h1 dangerouslySetInnerHTML={{ __html: banners[current].heading }}></h1>

            <Link to={banners[current].link} className="btn">
              {banners[current].button}
            </Link>
          </div>
        </div>
      </section>

      {/* Business Showcase Section */}
      <section className="business-showcase">
        <div className="business-content">
          {/* Left Section with Logo */}
          <div className="left-box">
            <p>
              "Switching to Recla was one of the best decisions for our company. Not only did we cut our printing costs by nearly 20%, but their after-sales support has been outstanding as well. Whenever we’ve had an issue, their team has been available even at odd hours. It feels less like working with a vendor and more like having a true partner who cares about our business success."
            </p>

            <div className="review-section">
              {/* Review Text */}
              <div className="review-text-container">

                {/* Rating Stars */}
                <div className="rating-stars">
                  <span className="star marked"></span>
                  <span className="star marked"></span>
                  <span className="star marked"></span>
                  <span className="star marked"></span>
                  <span className="star marked half"></span>
                </div>

                <h2 className="review-count">(10k+ Positive Reviews)</h2>
              </div>

              {/* Reviewer Images */}
              <div className="review-images">
                <img src="https://demo.bosathemes.com/bosa/business-firm/wp-content/uploads/sites/128/2024/09/review-4.jpg" alt="Reviewer" />
                <img src="https://demo.bosathemes.com/bosa/business-firm/wp-content/uploads/sites/128/2024/09/review-5.jpg" alt="Reviewer" />
                <img src="https://demo.bosathemes.com/bosa/business-firm/wp-content/uploads/sites/128/2024/09/review-6.jpg" alt="Reviewer" />
                <img src="https://demo.bosathemes.com/bosa/business-firm/wp-content/uploads/sites/128/2024/09/review-3.jpg" alt="Reviewer" />
                <img src="https://demo.bosathemes.com/bosa/business-firm/wp-content/uploads/sites/128/2024/09/review-2.jpg" alt="Reviewer" />
              </div>
            </div>

          </div>


          {/* Right Side Big Image */}
          <div className="business-image">
            <img
              src="https://demo.bosathemes.com/bosa/business-firm/wp-content/uploads/sites/128/2024/09/banner-img.png"
              alt="business showcase"
            />
          </div>

          {/* Right Section */}
          <div className="right-box">
            <Logo type="tg" link="/home" />
            <h2>Why Recla?</h2>
            <p>We’re not just suppliers. We’re partners in helping your business grow.
            </p>
            <ul className="service-list">
              <li>✔ Save up to 20% on printing costs</li>
              <li>✔ Rely on our 24×7 maintenance support</li>
              <li>✔ Backed by a proven global track record</li>
              <li>✔ Access world-class products at local prices</li>
              <li>✔ Get assistance importing any product you need</li>
            </ul>
          </div>
        </div>
      </section>

      {/* About Section */}
      <AboutSection />
      <Journey />
      {/* Services Offers */}
      <ServiceOffer />
      <NeedAbout />
      <SmarterMove />
    </div>
  );
}
